export default "__VITE_ASSET__CNwy6R6f__"